var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgButtonPhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "100px",
    height: "100px",
    viewBox: "0 0 100 100",
    enableBackground: "new 0 0 100 100",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0,
    fill: "none",
    width: 100,
    height: 100
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M83.018,47.902c0,0.415-0.008,0.831-0.025,1.242h4.977c0.016-0.413,0.023-0.827,0.023-1.242 c0-19.91-16.139-36.048-36.049-36.048c-0.416,0-0.832,0.006-1.242,0.02v4.976c0.41-0.016,0.826-0.023,1.242-0.023 C69.105,16.826,83.018,30.739,83.018,47.902z M78.047,47.902c0,0.415-0.01,0.831-0.031,1.242h-4.979 c0.025-0.411,0.037-0.825,0.037-1.242c0-11.671-9.461-21.132-21.131-21.132c-0.416,0-0.832,0.012-1.242,0.036v-4.979 c0.41-0.02,0.826-0.029,1.242-0.029C66.359,21.798,78.047,33.484,78.047,47.902z M68.104,47.902c0,0.417-0.016,0.831-0.049,1.242 h-4.99c0.043-0.408,0.066-0.821,0.066-1.242c0-6.181-5.01-11.189-11.188-11.189c-0.42,0-0.838,0.024-1.242,0.069v-4.993 c0.41-0.03,0.824-0.047,1.242-0.047C60.869,31.742,68.104,38.979,68.104,47.902z M21.07,18.744c2.12-1.747,5.253-1.445,6.999,0.674 l7.182,8.712c1.748,2.119,1.444,5.253-0.675,6.999l-2.283,1.884L18.784,20.628L21.07,18.744z M16.678,22.356 c0.153-0.129,0.313-0.252,0.478-0.367L31.008,38.5c-1.841,2.69-1.752,6.378,0.446,8.998l16.614,19.797 c2.199,2.619,5.814,3.348,8.787,2.002l12.979,15.467c-0.143,0.145-0.289,0.279-0.445,0.41c-7.027,5.896-21.052,4.678-41.014-19.113 C8.412,42.276,9.648,28.254,16.678,22.356z M67.703,67.068c-1.748-2.117-4.883-2.42-7.002-0.674l-2.287,1.887L71.16,83.742 l2.285-1.887c2.123-1.744,2.424-4.879,0.676-7L67.703,67.068z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonPhone);
export default __webpack_public_path__ + "static/media/button-phone.2cc85af5.svg";
export { ForwardRef as ReactComponent };